<template>
  <header class="app-header" :class="{ 'header-scrolled': isScrolled }">
    <v-container class="header-container">
      <div class="header-inner">
        <!-- Логотип -->
        <a href="#hero" class="logo-link" @click.prevent="scrollTo('#hero')">
          <img
            src="@/assets/ozo_logo.svg"
            alt="OZO.direct"
            class="logo-image"
          />
        </a>

        <!-- Навигация для десктопа -->
        <nav class="desktop-nav d-none d-md-flex">
          <a
            v-for="item in navLinks"
            :key="item.target"
            :href="item.target"
            class="nav-link"
            @click.prevent="scrollTo(item.target)"
          >
            {{ item.label }}
          </a>
        </nav>

        <!-- CTA Кнопка и бургер-меню -->
        <div class="header-actions">
          <v-btn
            rounded
            elevation="0"
            class="btn-header-cta d-none d-sm-flex"
            @click="scrollTo('#contact')"
          >
            Подключить
          </v-btn>

          <!-- Кнопка мобильного меню -->
          <v-btn
            icon
            class="d-flex d-md-none ml-2"
            @click="drawer = !drawer"
            aria-label="Меню"
          >
            <i
              :class="drawer ? 'ri-close-line' : 'ri-menu-4-line'"
              style="font-size: 24px; color: #18191c"
            ></i>
          </v-btn>
        </div>
      </div>
    </v-container>

    <!-- Мобильное выпадающее меню -->
    <v-expand-transition>
      <div v-if="drawer" class="mobile-menu d-md-none">
        <v-container>
          <div class="mobile-nav-list">
            <a
              v-for="item in navLinks"
              :key="item.target"
              :href="item.target"
              class="mobile-nav-link"
              @click.prevent="handleMobileNav(item.target)"
            >
              {{ item.label }}
            </a>
            <v-btn
              block
              rounded
              elevation="0"
              class="btn-header-cta mt-4"
              @click="handleMobileNav('#contact')"
            >
              Заказать демонстрацию
            </v-btn>
          </div>
        </v-container>
      </div>
    </v-expand-transition>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  data() {
    return {
      isScrolled: false,
      drawer: false,
      navLinks: [
        { label: "Экосистема", target: "#ecosystem" },
        { label: "Преимущества", target: "#advantages" },
        { label: "Интеграции", target: "#integrations" },
        { label: "OZO.OFFICE", target: "#analytics" },
        { label: "Клиенты", target: "#clients" },
        { label: "Тарифы", target: "#pricing" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    scrollTo(selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleMobileNav(selector) {
      this.drawer = false;
      this.scrollTo(selector);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 72px;
  display: flex;
  align-items: center;

  &.header-scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    height: 64px;
  }
}

.header-container {
  max-width: $container-max-width;
  margin: 0 auto;
  padding-top: 0;
  padding-bottom: 0;
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;

  .logo-image {
    height: 34px;
    width: auto;
  }
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 24px;

  .nav-link {
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    color: $color-text-dark;
    transition: color 0.2s ease;
    padding: 6px 4px;

    &:hover {
      color: #0b7a3a;
    }
  }
}

.btn-header-cta {
  background-color: $color-neon-green !important;
  color: $color-graphite !important;
  font-weight: 700;
  font-size: 14px;
  text-transform: none;
  letter-spacing: 0;
  padding: 0 20px !important;
  height: 40px !important;
  box-shadow: $shadow-neon !important;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(0, 230, 118, 0.4) !important;
  }
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
  padding: 16px 0 24px;
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-nav-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .mobile-nav-link {
    text-decoration: none;
    font-size: 16px;
    font-weight: 600;
    color: $color-text-dark;
    padding: 8px 0;
    border-bottom: 1px solid #f1f5f9;

    &:hover {
      color: #0b7a3a;
    }
  }
}
</style>
